__turbopack_context__.v({
  "contactButton": "styles-module-scss-module__-GOgea__contactButton",
  "formSelector": "styles-module-scss-module__-GOgea__formSelector",
  "formSelectorDrawer": "styles-module-scss-module__-GOgea__formSelectorDrawer",
  "getInTouchContainer": "styles-module-scss-module__-GOgea__getInTouchContainer",
  "linkButton": "styles-module-scss-module__-GOgea__linkButton",
  "textBlock": "styles-module-scss-module__-GOgea__textBlock",
});
